import { Chip } from "@heroui/react"
import { badgeStylesBySize, formattedDateRange } from "@helpers"
import { CalendarDaysIcon } from "@heroicons/react/24/outline"
import PropTypes from "prop-types"

const EventDateRangeBadge = ({ size = "md", startDate, endDate, isFullWidth = false }) => {
  const badgeStyles = badgeStylesBySize(size)

  return (
    <Chip size={size} classNames={{ base: `${isFullWidth ? "w-full" : "w-100"} max-w-none bg-blue-400` }}>
      <span className={`flex items-center justify-center text-white px-2 ${badgeStyles.font} font-semibold`}>
        <CalendarDaysIcon className="w-auto h-5 mr-1" />
        {formattedDateRange(startDate, endDate, true, "ddd D", "MMM", "")}
      </span>
    </Chip>
  )
}

EventDateRangeBadge.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default EventDateRangeBadge
